// extracted by mini-css-extract-plugin
export default {"content":"UserAddedCompanies_content__zPOa-","filters":"UserAddedCompanies_filters__i5c47","form":"UserAddedCompanies_form__NYsON"};